/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPurchaseInvoicePositionDto
 */
export interface GetPurchaseInvoicePositionDto {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseInvoicePositionDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseInvoicePositionDto
     */
    netAmount: string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseInvoicePositionDto
     */
    vat: string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseInvoicePositionDto
     */
    vatAmount: string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseInvoicePositionDto
     */
    purchaseInvoiceId: string;
}

/**
 * Check if a given object implements the GetPurchaseInvoicePositionDto interface.
 */
export function instanceOfGetPurchaseInvoicePositionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "netAmount" in value;
    isInstance = isInstance && "vat" in value;
    isInstance = isInstance && "vatAmount" in value;
    isInstance = isInstance && "purchaseInvoiceId" in value;

    return isInstance;
}

export function GetPurchaseInvoicePositionDtoFromJSON(json: any): GetPurchaseInvoicePositionDto {
    return GetPurchaseInvoicePositionDtoFromJSONTyped(json, false);
}

export function GetPurchaseInvoicePositionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPurchaseInvoicePositionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'netAmount': json['netAmount'],
        'vat': json['vat'],
        'vatAmount': json['vatAmount'],
        'purchaseInvoiceId': json['purchaseInvoiceId'],
    };
}

export function GetPurchaseInvoicePositionDtoToJSON(value?: GetPurchaseInvoicePositionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'netAmount': value.netAmount,
        'vat': value.vat,
        'vatAmount': value.vatAmount,
        'purchaseInvoiceId': value.purchaseInvoiceId,
    };
}

